import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';

import Cookies from 'js-cookie';
import { getToken } from '@/utils/auth';

Vue.use(Vuex);

export default new Vuex.Store({
  plugins: [createPersistedState({
    storage: window.sessionStorage,
    paths: [
      'iResa', 'fromPegase', 'fromHello', 'helloGroup', 'returnTo', 'alphaWorkspace'
    ]
  })],
  state: {
    alphaWorkspace: null,
    alphaWorkspaces: [],
    selectedCustomers: [],
    deselectedCustomers: [],
    returnTo: null,
    fromPegase: false,
    fromHello: false,
    helloGroup: null,
    addContactMode: {
      active: false,
      customer_uuid: null
    },
    duplicateContactMode: {
      active: false,
      customer: null
    },
    user: {},
    brand: Cookies.get('brand'),
    token: getToken(),
    search: {},
    iResa: {},
    keepAlive: true,
    include: [],
    advancedFieldSearchConfig: [
      { label: 'Prénom', field_name: 'firstname', type: 'text', placeholder: 'Jean', col: 'col-6', typo_tolerance: true },
      { label: 'Nom', field_name: 'lastname', type: 'text', placeholder: 'Dupont', col: 'col-6', typo_tolerance: true },
      { label: 'Code Postal', field_name: 'zip_code', type: 'number', placeholder: '000000', col: 'col-6' },
      { label: 'Ville', field_name: 'town', type: 'text', col: 'col-6', placeholder: 'Ville' },
      { label: 'Date de Naissance', field_name: 'birth_date', type: 'date', placeholder: '28/05/1995', col: 'col-6', show: false },
      { label: 'ID', field_name: 'uuid', type: 'number', placeholder: '000000', col: 'col-6', facet: ['sso_id', 'uuid', 'horanet_id'] },
      { label: 'Tél', field_name: 'telephone', type: 'number', placeholder: '000000', col: 'col-6' },
      { label: 'Mobile', field_name: 'mobilephone', type: 'number', placeholder: '000000', col: 'col-6' },
      { label: 'Email', field_name: 'email', type: 'text', placeholder: 'email@test.com', col: 'col-6' },
      { label: 'Compte digital', field_name: 'digital_account', type: 'toggle', col: 'col-6' },
      { label: 'Nº commande', field_name: 'commande', type: 'text', col: 'col-6', placeholder: 'Nº commande', facet: ['orders.uuid', 'orders.order.system_booking_number'] },
      { label: 'SSO ID', field_name: 'sso_id', type: 'text', placeholder: 'SSO ID', col: 'col-6' },
      { label: 'N° adhérent', field_name: 'membershipNumber', type: 'text', placeholder: 'N° adhérent', col: 'col-12' }
    ],
    alphaPaymentsToSync: [],
    deactivatedPartners: []
  },
  mutations: {
    setAlphaPaymentToSync (state, data) {
      Vue.set(state, 'alphaPaymentsToSync', data);
    },
    addDeselectedCustomersCustomer (state, data) {
      const deselectedCustomers = [...state.selectedCustomers];
      const customer = deselectedCustomers.find(c => c.uuid === data.uuid);

      if (!customer) {
        deselectedCustomers.push(data);
        Vue.set(state, 'deselectedCustomers', deselectedCustomers);
      }
    },
    removeDeselectedCustomersCustomer (state, data) {
      const deselectedCustomers = [...state.deselectedCustomers];
      const index = deselectedCustomers.findIndex(c => c.uuid === data.uuid);

      if (index !== -1) {
        deselectedCustomers.splice(index, 1);
        Vue.set(state, 'deselectedCustomers', deselectedCustomers);
      }
    },
    setDesselectedCustomer (state, data) {
      Vue.set(state, 'deselectedCustomers', data);
    },
    addSelectedCustomer (state, data) {
      const selectedCustomers = [...state.selectedCustomers];
      const customer = selectedCustomers.find(c => c.uuid === data.uuid);

      if (!customer) {
        selectedCustomers.push(data);
        Vue.set(state, 'selectedCustomers', selectedCustomers);
      }
    },
    removeSelectedCustomer (state, data) {
      const selectedCustomers = [...state.selectedCustomers];
      const index = selectedCustomers.findIndex(c => c.uuid === data.uuid);

      if (index !== -1) {
        selectedCustomers.splice(index, 1);
        Vue.set(state, 'selectedCustomers', selectedCustomers);
      }
    },
    setSelectedCustomer (state, data) {
      Vue.set(state, 'selectedCustomers', data);
    },
    setReturnTo (state, data) {
      Vue.set(state, 'returnTo', data);
    },
    setFromPegase (state, data) {
      Vue.set(state, 'fromPegase', data);
    },
    setFromHello (state, data) {
      Vue.set(state, 'fromHello', data);
    },
    setHelloGroup (state, data) {
      Vue.set(state, 'helloGroup', data);
    },
    setAddContactMode (state, data) {
      const addContactMode = { ...state.addContactMode, ...data };
      Vue.set(state, 'addContactMode', addContactMode);
    },
    setDuplicateContactMode (state, data) {
      const duplicateContactMode = { ...state.duplicateContactMode, ...data };
      Vue.set(state, 'duplicateContactMode', duplicateContactMode);
    },
    setToken (state, data) {
      Vue.set(state, 'token', data);
    },
    setUser (state, data) {
      Vue.set(state, 'user', data);
    },
    setBrand (state, data) {
      Vue.set(state, 'brand', data);
      Cookies.set('brand', data);
    },
    setIresa (state, iResa) {
      Vue.set(state, 'iResa', iResa);
    },
    setSearch (state, search) {
      Vue.set(state, 'search', search);
    },
    setInclude (state, include) {
      Vue.set(state, 'include', include);
    },
    setKeepAlive (state, value) {
      Vue.set(state, 'keepAlive', value);
    },
    setAlphaWorkspace (state, value) {
      Vue.set(state, 'alphaWorkspace', value);
    },
    setAlphaWorkspaces (state, value) {
      Vue.set(state, 'alphaWorkspaces', value);
    },
    setDeactivatedPartners (state, value) {
      Vue.set(state, 'deactivatedPartners', value);
    }
  },
  getters: {
    isReturnToPegase: state => state.returnTo === 'pegase',
    isReturnToHello: state => state.returnTo === 'hello',
    getBrand: state => state.brand,
    getDeactivatedPartners: state => state.deactivatedPartners
  }
});
